export const CATEGORY_TREE = [
  {
    name: "Network Issues",
    subcategories: [
      "No Internet Access",
      "Weak WiFi/LTE Signal",
      "WiFi Credentials Changed",
      "WiFi Disconnected / Unstable",
      "Auto WiFi Disconnected",
      "Weak Internet Speed",
    ],
  },
  {
    name: "Power Issues",
    subcategories: [
      "Power Disconnected / Unplugged",
      "Power Supply Failure",
      "Power Socket Not Working",
      "TV Turned Off",
      "Loose Connection",
      "Disconnected Due to Store Payment Issue",
      "Power Disconnected Due to Inappropriate Ads",
    ],
  },
  {
    name: "Stick / Device Issues",
    subcategories: [
      "Player Device Fault",
      "Player Reboot Loop",
      "Android Crash / Recovery Mode",
      "Device Not Installed Properly",
      "Old Device",
      "Stick Missing",
    ],
  },
  {
    name: "Display Issues",
    subcategories: [
      "Screen Hardware Fault",
      "Screen Missing",
      "No Signal from Source",
      "HDMI / Cable Fault",
      "Loose HDMI Connection",
      "HDMI Port Fault",
      "Dolphin Screen USB Fault",
      "TV Input Changed",
      "TV Screen Damaged",
      "Adapter Is Not Working",
    ],
  },
  {
    name: "Configuration",
    subcategories: [
      "Home Screen Showing",
      "TMV Not Working",
      "TMV / APK Updated",
      "Campaign Not Attached / Expired",
      "Stuck on Dplayer Code",
    ],
  },
  {
    name: "Store Issues",
    subcategories: [
      "Permanently Closed",
      "Business Closed for the Day",
      "Store Under Renovation / Temporarily Closed",
      "Ownership Changed",
      "Moved Within the Store",
      "Reallocated to Another Location",
      "Manager / Staff Refused to Cooperate",
    ],
  },
  {
    name: "Removal",
    subcategories: [
      "Owner Requested Removal",
      "Low Revenue Generated",
      "PA Removed the Screen",
      "Payment Issue",
    ],
  },
  {
    name: "Issue Not Resolved (Follow-up Required)",
    subcategories: [
      "No Hardware / Insufficient Hardware",
      "Manager / Staff Refused to Cooperate",
    ],
  },
  {
    name: "Other",
    subcategories: [
      "No Issue Found",
      "Other (Specify in Notes)",
    ],
  },
];


const SUBCATEGORIES = CATEGORY_TREE.flatMap(c => c.subcategories);
export const CATEGORIES = [...new Set(SUBCATEGORIES)];
export const PARENT_CATEGORIES = CATEGORY_TREE.map(c => c.name);
export function subcategoriesFor(parentName) {
  const found = CATEGORY_TREE.find(c => c.name === parentName);
  return found ? found.subcategories : [];
}
